 import React from "react";
import { useNavigate } from "react-router-dom";

import Navbar from "../../components/Navbar";
import SecondNavbar from "../../components/SecondNavbar";
import Footer from "../../components/Footer";

import "./Air.css";

import bannerImg from "../../assets/2.jpg";
import indoorImg from "../../assets/indoor.jpg";
import outdoorImg from "../../assets/outdoor.jpg";
import industryImg from "../../assets/industry.jpg";
import vehicleImg from "../../assets/vehicle.jpg";

const AirAwareness = () => {
  const navigate = useNavigate();

  const pollutionTypes = [
    { img: indoorImg, title: "Indoor Pollution", text: "Indoor pollution is caused by smoke, chemicals, and poor ventilation inside homes and buildings." },
    { img: outdoorImg, title: "Urban Smog", text: "Smog forms due to vehicle emissions and industrial gases in crowded cities." },
    { img: industryImg, title: "Industrial Pollution", text: "Factories release harmful gases and toxic particles into the atmosphere." },
    { img: vehicleImg, title: "Vehicle Emissions", text: "Cars and transport systems emit carbon monoxide and nitrogen oxides." },
  ];

  return (
    <div className="air-page-wrapper">
      <Navbar />
      <SecondNavbar />

      <section className="air-hero" style={{ backgroundImage: `url(${bannerImg})` }}>
        <div className="hero-overlay">
          <div className="hero-content">
            <h1>Clean Air <span>Matters</span></h1>
            <p>Understanding air pollution and protecting our environment for a healthier and sustainable future.</p>
            <button className="primary-btn" onClick={() => navigate("/awareness/air-type")}>
              Explore Awareness
            </button>
          </div>
        </div>
      </section>

      <section className="sources-section">
        <div className="section-header">
          <h2>Types of Air Pollution</h2>
          <p>Different forms of pollution affect human health, ecosystems, and the overall quality of life.</p>
        </div>
        <div className="sources-grid">
          {pollutionTypes.map((item, idx) => (
            <div className="source-card" key={idx}>
              <div className="source-image"><img src={item.img} alt={item.title} /></div>
              <div className="source-content"><h3>{item.title}</h3><p>{item.text}</p></div>
            </div>
          ))}
        </div>
      </section>

      <section className="info-section">
        <div className="info-image"><img src={industryImg} alt="Types of Pollution" /></div>
        <div className="info-content">
          <h2>Types of Air Pollution</h2>
          <p>Air pollution includes industrial smoke, indoor pollution, harmful gases, particulate matter, and toxic chemicals.</p>
          <button className="info-btn" onClick={() => navigate("/awareness/air-type")}>Learn More</button>
        </div>
      </section>

      <section className="info-section reverse">
        <div className="info-image"><img src={vehicleImg} alt="Causes of Pollution" /></div>
        <div className="info-content">
          <h2>Causes of Air Pollution</h2>
          <p>Major causes include vehicle emissions, industrial activities, burning fossil fuels, deforestation, and waste burning.</p>
          <button className="info-btn" onClick={() => navigate("/awareness/air-causes")}>Learn More</button>
        </div>
      </section>

      <section className="info-section">
        <div className="info-image"><img src={outdoorImg} alt="Effects of Pollution" /></div>
        <div className="info-content">
          <h2>Effects of Air Pollution</h2>
          <p>Air pollution can cause breathing problems, lung diseases, heart issues, environmental damage, and global warming.</p>
          <button className="info-btn" onClick={() => navigate("/awareness/air-effect")}>Learn More</button>
        </div>
      </section>

      <section className="prevention-section">
        <div className="prevention-content">
          <h2>How Can We Reduce Air Pollution?</h2>
          <div className="tips-grid">
            <div className="tip-card"><h3>Use Public Transport</h3><p>Reduce vehicle emissions by using buses and carpooling.</p></div>
            <div className="tip-card"><h3>Plant More Trees</h3><p>Trees naturally clean the air and absorb harmful gases.</p></div>
            <div className="tip-card"><h3>Save Energy</h3><p>Conserving electricity reduces pollution from power plants.</p></div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AirAwareness;